



















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Layout from '@/views/layout/index.vue';
@Component({})
export default class Table extends Vue {
  @Prop({
    type: String,
    default() {
      return '';
    }
  })
  type!: string;
  @Prop({
    type: Array,
    default() {
      return [];
    },
    required: true
  })
  list!: any[];
  @Prop({
    type: Number,
    default() {
      return 0; // 设为0用于监听loading
    }
  })
  curPage!: number;
  @Prop({
    type: Number,
    default() {
      return 20;
    }
  })
  pageSize!: number;
  @Prop({
    type: Object,
    default() {
      return {};
    },
    required: true
  })
  layout!: any[];
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleSelectionChange!: Function;
  get loading() {
    return this.list && this.curPage > 0 ? false : true;
  }
  // private loading = true;
  private indexMethod(idx: number) {
    return (this.curPage - 1) * this.pageSize + idx + 1;
  }
}
